import * as yup from 'yup';
import * as Schema from '../schemaFields';

export const questionDistanceSchema = yup.object({
  distance: Schema.requiredPositiveNumber,
});
